export default "__VITE_ASSET__Cminsmel__"